export const colors = {
  blue: '#348EE9',
  darkBue: '#348EE91A',
  blueHover: '#2C7FD2',
  secondaryButton: '#D2E8FF33',
  secondaryButtonHover: '#D2E8FF66',
  secondaryButtonDisabled: '#CDCDCD',
  secondaryButtonDisabledBordder: '#808080',
  grayPlaceholder: '#9C9C9C',
  mainDark: '#000000',
  secondaryDark: '#00060C',
  dark: '#1A1A1A',
  mainGray: '#8B8E93',
  gray: '#D9D9D9',
  lightGray: '#EFEFEF',
  darkGray: '#363636',
  white: '#FFFFFF',
  textPrimary: '#222222',
  textSecondary: '#616161',
  brandLightGrey: '#EFF0F2',
  brandGrey: '#CCCCCC',
  borderColor: '#E5E5E5',
  oliveBlack: 'rgb(8, 6, 0)',
  brandLightGreyTwo: '#F6F6F6',
};
